<template>
    <div>
        <!-- Popup modal lorsqu'une incohérence est détéctée -->
        <v-dialog width="500" max-width="100%" scroll-strategy="none" v-model="show">
            <v-card>
                <v-card-text>
                    <p>Attention ! Notre système a repéré une possible incohérence dans vos informations personnelles :
                    </p>
                    <p v-if="!incoherence.nom_valide">Nous avons détecté un prénom dans le champ nom, nous vous
                        invitons
                        à
                        vérifier votre saisie puis poursuivre votre inscription.</p>
                    <p v-if="!incoherence.prenom_valide">Votre prénom n'est pas référencé, nous vous invitons à
                        vérifier
                        son
                        orthographe puis poursuivre votre inscription.</p>
                    <p v-if="!incoherence.sexe_valide">Le sexe sélectionné ne correspond pas au prénom indiqué,
                        nous vous
                        invitons à vérifier votre choix (HOMME/FEMME) puis poursuivre votre inscription.</p>
                    <p>Si vos informations sont correctes, nous vous invitons à continuer et ne pas tenir compte de
                        cette alerte.
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary-dark" block @click="show = false">Continuer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: ['incoherence'],
    name: 'IncoherencePopupDialog',
    data() {
        return {
            show: false,
        };
    },
    watch: {
        incoherence: function (val) {
            if (val === null) {
                this.show = false;
            }
            if (val.nom_valide === false || val.prenom_valide === false || val.sexe_valide === false) {
                this.show = true;
            }
        },
    },

};
</script>

<style scoped>
/* Add your styles here */
</style>